module.exports = __webpack_public_path__ + "img/CT-horizontalni_boja.8c81eaa.svg";